import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import React from "react";
import { Tab, Tabs } from "@mui/material";
import { Box } from "@mui/material";
import { formatNumber } from "../../../Common/FormatNumber";

interface ChartProps {
    product: string;
    title: string;
    height: number;
}

const SalesByMarket = ({ product, title, height = 345 }: ChartProps) => {
    const [dollarsByMarket, setDollarsByMarket] = React.useState<any[]>([]);
    const [numberByMarket, setNumberByMarket] = React.useState<any[]>([]);
    const [value, setValue] = React.useState(0);
    const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`/dashboard/sales-by-market/${product}/?entity_id=${localStorage.getItem('entity_id')}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setDollarsByMarket(Array.isArray(data.sales) ? data.sales : []);
                setNumberByMarket(Array.isArray(data.numbers) ? data.numbers : []);
            } catch (err) {
                console.log(err);     
            } finally {}
        };
        fetchData();

        const handleResize = () => {
        if (chartComponentRef.current && chartComponentRef.current.chart) {
                chartComponentRef.current.chart.reflow();
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [product]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const dollarsByMarketOptions: Highcharts.Options = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
        },
        title: {
            text: 'Market Sales ($)',
            align: 'left',
            style: {
                fontFamily: 'Trebuchet MS',
                fontSize: '1rem'
            }
        },
        tooltip: {
            formatter: function(this: Highcharts.Point) {
                return `<span style="font-family: Trebuchet MS;">${this.name}<br/>Percentage: <b>${(this.percentage as number).toFixed(1)}%</b><br/>Sales: <b>${formatNumber(this.y as number, 'en-US', 'USD')}</b></span>`;
            }
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                },
                showInLegend: true
            }
        },
        series: [
            {
                type: 'pie',
                name: 'Sales by Market ($)',
                data: dollarsByMarket
            },
        ]
    }

    const numberByMarketOptions: Highcharts.Options = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
        },
        title: {
            text: 'Market Sales (No. of Customers)',
            align: 'left',
            style: {
                fontFamily: 'Trebuchet MS',
                fontSize: '1rem'
            }
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%<br/>Customers #: {point.y:,.0f}</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                },
                showInLegend: true
            }
        },
        series: [
            {
                type: 'pie',
                name: 'Sales by Market (No. of Customers)',
                data: numberByMarket
            },
        ]
    }

    return (
        <div style={{ height: '100%', width: '100%'}}>
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="wrapped label tabs example"
                >
                    <Tab value={0} label="Sales ($)" sx={{ textTransform: 'capitalize' }}/>
                    <Tab value={1} label="Number of Customers" sx={{ textTransform: 'capitalize' }}/>
                </Tabs>
            </Box>
            {value === 0 && (
                <HighchartsReact
                    highcharts={Highcharts}
                    options={dollarsByMarketOptions}
                    allowChartUpdate={true}
                    exportEnabled={true}
                    ref={chartComponentRef}
                    containerProps={{ style: { width: '100% !important', height: height, borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
                />
            )}
            {value === 1 && (
                <HighchartsReact
                    highcharts={Highcharts}
                    options={numberByMarketOptions}
                    allowChartUpdate={true}
                    exportEnabled={true}
                    ref={chartComponentRef}
                    containerProps={{ style: { width: '100% !important', height: height, borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
                />
            )}
        </div>
    );
};

export default SalesByMarket;